import { render, staticRenderFns } from "./ColourList.vue?vue&type=template&id=f647e9c8&scoped=true"
import script from "./ColourList.vue?vue&type=script&lang=js"
export * from "./ColourList.vue?vue&type=script&lang=js"
import style0 from "./ColourList.vue?vue&type=style&index=0&id=f647e9c8&prod&lang=scss&scoped=true"
import style1 from "./ColourList.vue?vue&type=style&index=1&id=f647e9c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f647e9c8",
  null
  
)

export default component.exports